// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"f55edaa0","986":"4e32b477"}[chunkId] + ".js";
};